import { curry } from 'ramda';

import { pushStatus, popStatus } from "./uiLoader.stack";

// (Promise, { status: String, delay: Number }) -> Promise
const showLoader = async (promise, options) => {
    pushStatus(options);

    try{
        return await promise;
    } finally{
        popStatus();
    }
};

const showLoaderText = curry((text, promise) => showLoader(promise, { status: text }));

export {
    showLoaderText,
};

export default showLoader;